import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefaufgabe-reihenfolge-setzen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefaufgabeReihenfolgeSetzenEffects {

    PruefaufgabeReihenfolgeSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFAUFGABE_REIHENFOLGE_SETZEN),
        mergeMap((x: ac.PostPruefaufgabeReihenfolgeSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefaufgabeReihenfolgeSetzen(x.pruefaufgabeReihenfolgeRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefaufgabeReihenfolgeSetzenErfolgreichAction(result, x.pruefaufgabeReihenfolgeRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefaufgabeReihenfolgeSetzenFehlerAction(error, x.pruefaufgabeReihenfolgeRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
